








































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { VNode, CreateElement } from 'vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import {
  dropdown,
  SwDropdownUnit,
  DropdownDirValues,
} from '@libs-uuif/shared/dropdown-dir';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';

const cssPrefix = 'sw-widget-header-settings';

@Component({
  components: {
    SwIcon,
    SwDropdownUnit,
  },
  directives: {
    dropdown,
  },
})
export default class SwWidgetHeaderSettings extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true })
  index: number;

  @Prop({ required: false })
  groupByOptions: string[];

  @Prop({ type: Boolean })
  isLoading: boolean;

  @Prop({ type: String, required: false, default: '' })
  groupBy: string;

  @Prop({ type: Boolean, required: false, default: false })
  disableRemove: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  disableEdit: boolean;

  showDropdown: boolean = false;
  options = [
    { content: 'Remove Widget', action: 'remove' },
    { content: 'Edit/Replace Widget', action: 'replace' },
  ];

  private removeWidget() {
    confirmService.confirm({
      message: 'Are you sure you want to remove this widget?',
      title: 'Confirmation',
      status: 'informational',
      buttons: [{
        key: 'cancel',
        name: 'Cancel',
      },
      {
        key: 'proceed',
        name: 'Proceed',
        isDefault: true,
      },
      ],
    })
    .then((confirmKey) => {
      if (confirmKey === 'proceed') {
        this.$emit('widgetRemoved', this.index);
      }
    });
  }

  // This computed property provides dropdown units
  get actionsDropdown(): DropdownDirValues {
    return {
      // tslint:disable-next-line
      content: (h: CreateElement): VNode[] => {
        const nodes: VNode[] = [];
        this.options.map((item) => {
          nodes.push(
            (
              <div class={[`${cssPrefix}__dropdown-border`]}>
                <SwDropdownUnit
                  nativeOn-click={() =>
                    this.performAction(item.action)
                  }
                  disabled={
                    this.groupBy === item.action ||
                    (this.disableRemove &&
                      item.action === 'remove') ||
                    (this.disableEdit &&
                      item.action === 'replace')
                  }
                >
                  <div
                    class={[
                      `${cssPrefix}__dropdown-break-word`,
                    ]}
                  >
                    <span>{item.content}</span>
                  </div>
                </SwDropdownUnit>
              </div>
            ) as VNode,
          );
        });
        return nodes;
      },
      visible: !this.isLoading && this.showDropdown,
      onClickOutsidePopper: () => {
        this.showDropdown = false;
      },
      placement: 'bottom-end',
    };
  }

  // This Function will be used to perform action based on the action type (remove | replace | Group by events )
  performAction(actionType: string) {
    switch (actionType) {
      case 'remove':
        this.removeWidget();
        break;
      case 'replace':
        this.$emit('widgetReplaced', this.index);
        break;
      default:
        this.$emit('widgetGroupedBy', {
          groupBy: actionType,
          index: this.index,
        });
        break;
    }
    this.showDropdown = false;
  }

  //  This function will be called, On clicking the dropdown. Will toggle dropdown showing behaviour
  onClickDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  // When the component is created, Group by options will be checked. If found, then it will be added in the options list.
  created() {
    if (this.groupByOptions) {
      this.groupByOptions.map((option: string) => {
        this.options.push({
          content: `Group by ${option}`,
          action: option,
        });
      });
    }
  }
}
